import { ITopicHeaders, MessageBroker, PostLoginActionNameEnum } from '@sparkware/uc-sdk-core';
import { UiChannel } from '@sparkware/uc-sdk-core/lib/message-broker/channels/ui/ui.channel';
import { UserInteractionChannel } from '@sparkware/uc-sdk-core/lib/message-broker/channels/user-interaction/user-interaction.channel';
import Container from 'typedi';
import { ClientIntegrationFacadeToken, FeatureAvailabilityToken } from '../../../injection-tokens';
import { ClientProvider, Features } from '../../../models/enums/Consts';
import { IClientIntegrationFacade } from '../../client-integration/interfaces/IClientIntegrationFacade';
import { NativeUtils } from '../../native/native.utils';
import {
    IPostLoginActionsState,
    IStartFavouriteSportsFlowPostLoginOptions,
} from '../models/IPostLoginActionsState';
import { PostLoginActionBase } from './post-login-action-base';
import { IFeatureAvailability } from '../../feature/feature-availability/feature-availability-interface';
import PageContextManager from 'page-context-manager';

const MB_HEADER: ITopicHeaders = { publisher: 'StartFavouriteSportsFlowPostLoginAction' };

export class StartFavouriteSportsFlowPostLoginAction extends PostLoginActionBase {
    private _uiChannel: UiChannel;
    private _userInteractionChannel: UserInteractionChannel;
    private _clientIntegrationFacade: IClientIntegrationFacade;
    private _featureAvailability: IFeatureAvailability;

    constructor(state: IPostLoginActionsState) {
        super(
            PostLoginActionNameEnum.StartFavouriteSportsFlow,
            'StartFavouriteSportsFlowPostLoginAction',
            state,
        );
        this._uiChannel = MessageBroker.getInstance().ui;
        this._userInteractionChannel = MessageBroker.getInstance().userinteraction;
        this._clientIntegrationFacade = Container.get(ClientIntegrationFacadeToken);
        this._featureAvailability = Container.get(FeatureAvailabilityToken);
    }

    protected override canExecute = (): Promise<boolean> => {
        const { name } = PageContextManager.getClientProviderData();
        const favouriteSportsEnabled = this._featureAvailability.IsFeatureEnabled(
            Features.FAVOURITE_SPORTS,
        );

        const canExecute = name === ClientProvider.Spectate && favouriteSportsEnabled;

        return Promise.resolve(canExecute);
    };

    protected override doAction = async (
        options?: IStartFavouriteSportsFlowPostLoginOptions,
    ): Promise<void> => {
        const { ReadyToConnect } = this._clientIntegrationFacade;

        await ReadyToConnect.promise;

        let topic = this._userInteractionChannel.topics.postRegistrationDepositClosed;

        this.clearOptions();

        if (this._interruptedDuringRegistration(options)) {
            topic = this._uiChannel.topics.openFavouriteSportsModal;
        }

        topic.publish(MB_HEADER, {});
        NativeUtils.showBottomBar(false);

        this.completeAction();
    };

    private _interruptedDuringRegistration = (
        options?: IStartFavouriteSportsFlowPostLoginOptions,
    ) => (options?.isRegistration || false) && this.wasFlowInterrupted();
}
